import locales from './locales';

export default function generateModalTemplate(suggestions, localization) {
  const {
    recommendedCountry,
    recommendedCountryCode,
    recommendedCurrency,
    recommendedLanguage,
    recommendedLanguageCode,
  } = suggestions;

  // Check if the language code is in the locales object, if not use English for the translations
  let translations = locales.en;
  if (locales[recommendedLanguageCode]) {
    translations = locales[recommendedLanguageCode];
  }

  // Check if the recommended country & language combination is in the localization object
  const recommendedLanguageCodeToUpperCase = recommendedLanguageCode
    ? recommendedLanguageCode.toUpperCase()
    : 'EN';
  const showRecommendedCountryLanguage = localization.availableCountries.some(
    country =>
      country.isoCode === recommendedCountryCode &&
      country.availableLanguages.some(
        language => language.isoCode === recommendedLanguageCodeToUpperCase,
      ),
  );

  // Get the localization countries count
  const localizationCountriesCount = localization.availableCountries.length;
  // Check if the localization currencies are different from the recommended currency
  const localizationCurrenciesAreDifferent = localization.availableCountries.some(
    country => country.currency.isoCode !== recommendedCurrency,
  );

  // Generate the localization country options
  const localizationCountryOptions = localization.availableCountries.map(country => {
    const { isoCode, name } = country;
    let currencyIsoCode = null;
    if (country.currency && localizationCurrenciesAreDifferent) {
      currencyIsoCode = country.currency.isoCode;
    }

    return `<option value="${isoCode}"${
      isoCode === recommendedCountryCode ? ' selected' : ''
    }>${name}${currencyIsoCode ? ` (${currencyIsoCode})` : ''}</option>`;
  });

  const showRecommendedCountry = recommendedCountry && localizationCountriesCount > 1;
  let recommendedCountryFlag = '';
  if (showRecommendedCountry) {
    recommendedCountryFlag = `https://cdn.shopify.com/static/images/flags/${recommendedCountryCode.toLowerCase()}.svg`;
  }

  const geolocationRecommendedContent = `
    <div class="geolocation__content | js-geolocation-recommended">
      ${
        showRecommendedCountry
          ? `<div class="geolocation__flag">
            <img src="${recommendedCountryFlag}" alt="${recommendedCountry}" width="75" height="48" />
          </div>`
          : ''
      }

      <p class="h2 geolocation__title">
        ${
          showRecommendedCountry
            ? `${translations.titleLocation} ${recommendedCountry}`
            : `${translations.titleLanguage} ${recommendedLanguage}`
        }
      </p>

      ${
        showRecommendedCountry
          ? `<ul class="geolocation__body">
              ${
                recommendedCurrency && localizationCurrenciesAreDifferent
                  ? `<li>${translations.shopIn} ${recommendedCurrency}</li>`
                  : ''
              }
              ${
                recommendedCountry
                  ? `<li>${translations.shippingOptions} ${recommendedCountry}</li>`
                  : ''
              }
              ${
                recommendedLanguage
                  ? `<li>${translations.languageSetTo} ${recommendedLanguage}</li>`
                  : ''
              }
            </ul>`
          : ''
      }

      <div class="geolocation__ctas">
        <form action="/localization" method="post">
          <input type="hidden" name="_method" value="PUT" />
          <input type="hidden" name="return_to" value="${window.location.pathname}" />
          <input type="hidden" name="country_code" value="${recommendedCountryCode}">
          <input type="hidden" name="language_code" value="${recommendedLanguageCode}">

          <button type="submit" class="button button--full | js-geolocation-submit">
            ${translations.continue}
          </button>
        </form>

        <button class="geolocation__cta | js-geolocation-change">
          ${
            showRecommendedCountry
              ? translations.changeCountryLanguage
              : translations.changeLanguage
          }
        </button>
      </div>
    </div>
  `;

  return `
    ${showRecommendedCountryLanguage ? geolocationRecommendedContent : ''}

    <div class="geolocation__content | js-geolocation-select"${
      showRecommendedCountryLanguage ? ' style="display: none;"' : ''
    }>
      <div class="h2 geolocation__title">
        ${translations.changeCountryLanguage}
      </div>

      ${
        !showRecommendedCountry
          ? `<div class="geolocation__info">
              ${translations.infoCountryNotAvailableForShipping}
            </div>`
          : ''
      }

      <div class="geolocation__form-wrapper">
        <form action="/localization" method="post" class="geolocation__form">
          <input type="hidden" name="_method" value="PUT" />
          <input type="hidden" name="return_to" value="${window.location.pathname}" />

          <div class="geolocation__select">
            <label for="GeolocationCountrySelect" class="vh">${translations.country}</label>
            <select id="GeolocationCountrySelect" name="country_code" class="select">
              ${localizationCountryOptions.join('')}
            </select>
          </div>

          <div class="geolocation__select">
            <label for="GeolocationLanguageSelect" class="vh">${translations.language}</label>
            <select id="GeolocationLanguageSelect" name="language_code" class="select">
            </select>
          </div>
          <button type="submit" class="button button--full | js-geolocation-submit">${
            translations.submit
          }</button>
        </form>

        ${
          showRecommendedCountryLanguage
            ? `<button class="geolocation__cta | js-geolocation-back">${translations.back}</button>`
            : ''
        }
      </div>
    </div>

    <button type="button" class="modal__close | js-modal-close">
      <div class="icon icon-close">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.1 17.1">
          <path d="M17.1 1.1 16 0 8.5 7.5 1.1 0 0 1.1l7.5 7.4L0 16l1.1 1.1 7.4-7.5 7.5 7.5 1.1-1.1-7.5-7.5 7.5-7.4z"/>
        </svg>
      </div>
      <span class="vh">${translations.close}</span>
    </button>
  `;
}
